module.exports = __webpack_public_path__ + "static/media/hallmark.e3f13ba0.png";